import React from 'react';
import { getTheme, IconButton, Stack, Text } from '@fluentui/react';
import { useDisplayCreateWidgetModal } from 'features/Rooms/PersonalMeetingCorner/states/hooks';
import { more, globe, quote, upload, photo, book } from 'features/Rooms/PersonalMeetingCorner/assets/icons';
import { widgetStyles } from 'features/Rooms/PersonalMeetingCorner/components/Widgets/Widget.styles';
import { useCreateOrUpdateWidget } from 'features/Rooms/PersonalMeetingCorner/states/hooks';
import IvicosStrings from 'kits/language/stringKit';

const theme = getTheme();

const AddWidgets: React.FC = () => {
    const [, setDisplayCreateWidgetModal] = useDisplayCreateWidgetModal();
    const [, setCreateOrUpdateWidget] = useCreateOrUpdateWidget();

    return (
        <Stack className={widgetStyles.addWidgetButton} tokens={{ childrenGap: theme.spacing.m }}>
            <Stack
                verticalAlign="center"
                horizontalAlign="center"
                styles={{ root: { minHeight: 120 } }}
                onClick={() => {
                    setDisplayCreateWidgetModal('art-gallery');
                    setCreateOrUpdateWidget('create');
                }}
            >
                <IconButton
                    iconProps={{ iconName: 'Add' }}
                    styles={{
                        root: {
                            fontSize: 32,
                            color: theme.palette.neutralPrimary,
                            marginBottom: theme.spacing.s1
                        }
                    }}
                    ariaLabel={IvicosStrings.personalMeetingCornerStrings.addWidgets.addWidgetAriaLabel}
                />
                <Text variant="medium" styles={{ root: { color: theme.palette.neutralPrimary } }}>
                    {IvicosStrings.personalMeetingCornerStrings.addWidgets.addWidget}
                </Text>
            </Stack>
            <Stack horizontal horizontalAlign="center" tokens={{ childrenGap: 20 }} style={{ marginTop: 50, width: '100%' }}>
                {[photo, upload, quote, globe, book].map((icon, idx) => (
                    <span
                        key={idx}
                        style={{
                            ...widgetStyles.widgetIconButtonStyles.root,
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            margin: '0px 6px'
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.background = widgetStyles.widgetIconButtonStyles.rootHovered.background)}
                        onMouseLeave={(e) => (e.currentTarget.style.background = widgetStyles.widgetIconButtonStyles.root.background)}
                    >
                        <img
                            src={icon}
                            alt=""
                            style={{ width: 16, height: 16 }}
                            onClick={(e) => {
                                e.stopPropagation();
                                const widgetTypes = ['art-gallery', 'image-upload', 'quote', 'urls', 'book'];
                                setDisplayCreateWidgetModal(widgetTypes[idx]);
                            }}
                        />
                    </span>
                ))}
            </Stack>
        </Stack>
    );
};

export default AddWidgets;
